import axios from 'axios'
import { EXCLUIR_CIDADE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirCidade (cod) {
  const url = `${URL}/cidades/${cod}/excluir`;
  return dispatch => axios.post(url, null , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_CIDADE,
        payload: response
      })
  );
}
